import { useTranslation } from 'react-i18next';

import { type ApiFormat, FORMAT_NAMES } from '../data/models';

/** The API formats a model family accepts. */
export function FormatChips({ formats }: { formats: readonly ApiFormat[] }) {
  const { t } = useTranslation();
  return (
    <ul className="format-chips" aria-label={t('prices.formats')}>
      {formats.map((format) => (
        <li key={format}>{FORMAT_NAMES[format]}</li>
      ))}
    </ul>
  );
}
